import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";


/**
 * Класс метаданных для типа узла дерева.
 * Метаданные позволяют управлять внешним видом и операциями с узлами раздельно по типам!
 */
@jsonObject
export class DxNodeType {
  /** Строковое обозначение типа узла. */
  @jsonMember({name: "type", constructor: String, emitDefaultValue: false, isRequired: false})
  private _type: string;

  /** Иконка для отображения данного типа узла. */
  @jsonMember({name: "icon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _icon: string;

  /** Выделять ли лэйбл узла жирным. */
  @jsonMember({name: "useBoldFont", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _useBoldFont: boolean = false;

  /** Поодерживает ли узел данного типа действие drag из режима drag-and-drop. */
  @jsonMember({name: "allowDrag", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _allowDrag: boolean = false;

  /** Поодерживает ли узел данного типа действие drop из режима drag-and-drop. */
  @jsonMember({name: "allowDrop", constructor: Boolean, emitDefaultValue: true, isRequired: false})
  private _allowDrop: boolean = false;

  /** Массив допустимых для данного типа узла действий тулбара. */
  @jsonArrayMember(String, {name: "allowedActionTypes", emitDefaultValue: true, isRequired: false})
  private _allowedActionTypes: string[] = [];

  /**
   * Тип действия при котором созадется новый инстанс узла с данным типом.
   * Необходимо для опреления типа узла по действию.
   */
  @jsonMember({name: "instantiationActionType", constructor: String, emitDefaultValue: false, isRequired: false})
  private _instantiationActionType: string;

  get hasIcon(): boolean {
    return !!this._icon;
  }

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(value: string) {
    this._icon = value;
  }

  get useBoldFont(): boolean {
    return this._useBoldFont;
  }

  set useBoldFont(value: boolean) {
    this._useBoldFont = value;
  }

  get allowDrag(): boolean {
    return this._allowDrag;
  }

  set allowDrag(value: boolean) {
    this._allowDrag = value;
  }

  get allowDrop(): boolean {
    return this._allowDrop;
  }

  set allowDrop(value: boolean) {
    this._allowDrop = value;
  }

  get allowedActionTypes(): string[] {
    return this._allowedActionTypes;
  }

  set allowedActionTypes(value: string[]) {
    this._allowedActionTypes = value;
  }

  get instantiationActionType(): string {
    return this._instantiationActionType;
  }

  set instantiationActionType(value: string) {
    this._instantiationActionType = value;
  }
}
